import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../customHooks/usePostHook";
const Createcustomercomponent = loadable(
  () => import("../../components/Customer/CreateCustomer")
);
const CreateCustomer = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["customer-info"],
    navigateURL: "/accounting/customer",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = APIS.CREATE_USER;
    const formData = {
      ...values,
      is_supplier: false,
    };

    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <div>
      <div className={tw`grid grid-cols-2 `}>
        <h1 className={tw`font-semibold text-xl leading-10`}>
          Create Customer
        </h1>
      </div>
      <Createcustomercomponent
        handleCreate={handleCreate}
        isLoading={isPostLoading}
      />
    </div>
  );
};

export default CreateCustomer;

